import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  "class": "auth-layout-container"
};
var _hoisted_2 = {
  "class": "flex justify-center items-center flex-1 p-2xl pb-0"
};
var _hoisted_3 = {
  key: 0,
  "class": "Section"
};
import Header from "@/layouts/main-layout/Header.vue";
import Footer from "@/layouts/main-layout/Footer.vue";
import Register from "@/pages/auth/Register.vue";
import Login from "@/pages/auth/Login.vue";
import "@/assets/styles/partials/login-form.css";

import { defineAsyncComponent, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'AuthLayout',
  setup: function setup(__props) {
    var ConfirmRegistration = defineAsyncComponent(function () {
      return import("@/pages/auth/ConfirmRegistration.vue");
    });
    var route = useRoute();
    var router = useRouter();
    var tabs = [{
      label: "Login",
      route: "login"
    }, {
      label: "Register",
      route: "register"
    }];
    var activeTab = ref(route.name === "register" ? "Register" : "Login");
    var component = computed(function () {
      return route.name === "register" ? Register : Login;
    });
    function routerPush(selectedTab) {
      var tab = tabs.find(function (tab) {
        return selectedTab === tab.label;
      });
      if (tab.route === route.name) {
        return;
      }
      router.push({
        name: tab.route
      });
    }
    watch(route, function (value) {
      activeTab.value = value.name === "register" ? "Register" : "Login";
    });
    return function (_ctx, _cache) {
      var _component_PBTab = _resolveComponent("PBTab");
      var _component_PBTabs = _resolveComponent("PBTabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Header, {
        empty: ""
      }), _createElementVNode("div", _hoisted_2, [_unref(route).name !== 'confirm-registration' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_PBTabs, {
        modelValue: _unref(activeTab),
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = function ($event) {
          return _isRef(activeTab) ? activeTab.value = $event : null;
        }), routerPush],
        route: "",
        border: ""
      }, {
        "default": _withCtx(function () {
          return [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, function (tab, index) {
            return _createVNode(_component_PBTab, {
              key: index,
              label: tab.label
            }, {
              "default": _withCtx(function () {
                return [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component))))];
              }),
              _: 2
            }, 1032, ["label"]);
          }), 64))];
        }),
        _: 1
      }, 8, ["modelValue"])])) : (_openBlock(), _createBlock(_unref(ConfirmRegistration), {
        key: 1
      }))]), _createVNode(Footer, {
        empty: ""
      })]);
    };
  }
};